import {
    Box, Button, Center, Container, Flex, HStack, Icon, Image, Modal, ModalBody, ModalContent, ModalFooter, ModalOverlay, Spinner, Stack, Table, Avatar,
    TableContainer,
    Tbody,
    Td, Text, Th,
    Thead,
    Tr, useDisclosure,
    VStack
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { MdError } from "react-icons/md";

const MainPart = () => {

    // Use the Member interface to type the memberList state variable
    const [memberList, setMemberList] = useState<any[]>([]);

    const { isOpen: loadingIsOpen, onOpen: loadingOnOpen, onClose: loadingOnClose } = useDisclosure();

    const getUsers = async () => {
        try {
            // クルクルを出す
            loadingOnOpen();

            // キャラDAOチャンネルのフォロワーfid一覧を取得
            const response = await fetch(`/.netlify/functions/warpcast`);

            // Netlify Function側でエラーがあった時の処理
            if (response.status === 500) {
                throw response.statusText;
            }

            const fids = await response.json();

            let users = [];

            for (let fid of fids) {
                // フォロワーの各種情報を取得
                const resp = await fetch(`/.netlify/functions/pinata?fid=${fid}`);

                // Netlify Function側でエラーがあった時の処理
                if (resp.status === 500) {
                    throw resp.statusText;
                }

                const data = await resp.json();
                // NetlifyFunctionからの戻り値
                // return {
                //     statusCode: 200,
                //     body: JSON.stringify({
                //         display_name: data.user.display_name,
                //         avatar_url: avatar_url,
                //         points: points
                //     }),
                // }

                // データが取得できた場合のみ、配列に追加
                if (data.avatar_url != "") {
                    users.push({ display_name: data.display_name, avatar_url: data.avatar_url, points: data.points });
                }
            }

            // pointsで降順にソート
            users.sort((a, b) => b.points - a.points);

            // Stateに反映
            setMemberList(users);

            loadingOnClose(); // クルクルを消す

        } catch (err) {
            loadingOnClose(); // クルクルを消す
            setFunctionOnError('getUsers');
            setErrorMessage((err as Error).toString());
            errorOnOpen();
        }
    }

    useEffect(() => {
        getUsers();
    }, []);

    /**
     * エラー表示モーダル
     */
    const [fuctionOnError, setFunctionOnError] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const { isOpen: errorIsOpen, onOpen: errorOnOpen, onClose: errorOnClose } = useDisclosure();

    return (
        <Container>
            <Center>
                <Flex m={3} mt={10} px={6} py={3} backgroundColor={'lightgray'} borderRadius={5}>
                    <Box display="flex" alignItems="center">
                        <Image src='degen.png' maxH={'40px'} objectFit='contain' />
                    </Box>
                    <Box ml={4}>
                        <Text fontSize={{ base: 'xl', md: '2xl' }} fontWeight={"bold"} color={'gray.600'}>Warpcast</Text>
                        <Text fontSize={{ base: 'xl', md: '2xl' }} fontWeight={"bold"} color={'gray.600'}>キャラDAOチャンネル</Text>
                    </Box>
                </Flex>
            </Center>
            <Center>
                <Text fontSize={{ base: 'xl', md: '2xl' }} fontWeight={"bold"} color={'gray.600'} mt={6}>DEGENポイント取得状況</Text>
            </Center>

            {memberList.length > 0 && (
                <>
                    <Center mt={3} mb={5} mx={10}>
                        <Text>🦊ウォレットを紐づけないとポイント取得できないようです</Text>
                    </Center>
                    <TableContainer borderWidth={3} p={{ base: '0', md: '6' }} pb={0}>
                        <Table variant='simple' size={{ base: 'sm', md: 'md' }}>
                            <Thead>
                                <Tr>
                                    <Th>ユーザー</Th>
                                    {/* <Th></Th> */}
                                    <Th isNumeric>ポイント</Th>
                                </Tr>
                            </Thead>

                            <Tbody>
                                {memberList.map((member, index) => (
                                    <Tr key={index}>
                                        <Td>
                                            <Flex>
                                                <Avatar src={member.avatar_url} size={{ base: 'sm', md: 'md' }} />
                                                <Center ml={2}>
                                                    {member.display_name}
                                                </Center>
                                            </Flex>
                                        </Td>
                                        <Td isNumeric>{member.points}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>
                    <Box m={5}>
                        <Center color={'red.500'}>なにか不具合がありましたら、ですもまでお知らせください🙇‍♂️</Center>
                    </Box>
                </>
            )}

            {/* 読み込み中 */}
            <Modal
                closeOnOverlayClick={false}
                isOpen={loadingIsOpen}
                onClose={loadingOnClose}
                isCentered
                size={'xl'}
                autoFocus={false}
                closeOnEsc={false}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalBody py={20}>
                        <Center>
                            <Spinner
                                thickness='4px'
                                speed='0.6s'
                                color='gray.600'
                                size='xl'
                            />
                        </Center>
                        <Center mt={50} fontSize={'xl'} >
                            頑張って読み込み中です・・・
                        </Center>
                        <Center mt={2} fontSize={'xl'} >
                            かなり時間が掛かります🙇‍♂️
                        </Center>
                    </ModalBody>
                </ModalContent>
            </Modal >

            {/* エラー表示 */}
            <Modal closeOnOverlayClick={false} isOpen={errorIsOpen} onClose={errorOnClose} isCentered size={'xl'}>
                <ModalOverlay />
                <ModalContent>
                    <ModalBody>
                        <Stack pt={10} px={{ base: '0', sm: '5' }}>
                            <HStack>
                                <Icon as={MdError} boxSize={6} color={'red.500'} mx={1} />
                                <Text color={'red.500'} fontSize={'lg'}>
                                    予期せぬエラー
                                </Text>
                            </HStack>
                            <Stack mt={5}>
                                <Text px={5}>
                                    {fuctionOnError} でエラーが発生しました
                                </Text>
                                <Text px={5} fontSize={'sm'}>
                                    エラーメッセージ<br />
                                    {errorMessage}
                                </Text>
                                <Text px={5} pt={5}>
                                    ですもまでお知らせください🙇‍♂️
                                </Text>
                                <Text px={5} fontSize={'sm'}>
                                    ※可能でしたら、この画面のスクショを添付ください
                                </Text>
                            </Stack>
                        </Stack>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            colorScheme='blue'
                            mr={3}
                            onClick={() => {
                                setFunctionOnError('');
                                setErrorMessage('');
                                errorOnClose();
                            }}
                        >
                            閉じる
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal >
        </Container >
    );
};

export default MainPart;